import { BASE_SSE_URL, BASE_URL, BASE_URL_V2 } from "../constants/constants";
import { DatasetProps, FType, APIVersions } from "../types/types";
import { buildPayload, buildHeaders } from "../utils/utils";

export const getOrderData = async (
  checkOutElement: DatasetProps,
  flowType: FType,
  apiVersion: APIVersions
) => {
  const payload = buildPayload(checkOutElement, flowType);
  const headers = buildHeaders(checkOutElement, apiVersion);
  const baseUrl = apiVersion === '1' ? BASE_URL : BASE_URL_V2;
  const url = `${baseUrl}/order`;

  const response = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  });

  if (response.status !== 201) {
    const errorResponse = await response.json();
    throw new Error("Order not created", { cause: errorResponse });
  }

  return response.json();
};

export const conectEventSource = (
  eventName: string,
  orderId?: number
): EventSource => {
  const eventSource: EventSource = new EventSource(
    `${BASE_SSE_URL}/sse-service/v1/sse-api-checkout/suscribe/${eventName}/orderId/${orderId}`
  );
  return eventSource;
};

export const listenerOpenEventSource = (
  eventSource: EventSource,
  callback: any
): void => {
  eventSource.onopen = callback;
};
export const listenerErrorEventSource = (
  eventSource: EventSource,
  callback: any
): void => {
  eventSource.onerror = callback;
};

export const listenerEventSource = (
  eventSource: EventSource,
  callback: any
): void => {
  eventSource.onmessage = callback;
};

export const removeListenerEventSource = (
  eventSource: EventSource | null
): void => {
  if (eventSource) eventSource.close();
};
